import React, { memo } from "react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import Skeleton from "react-loading-skeleton";

import AppSkeletonTheme from "../../../components/skeletons/AppSkeletonTheme";
import {
  EXPLORER_SEARCH_ROW_HEIGHT,
  explorerContentSx,
  explorerFilterGridSx,
  explorerRootSx,
} from "../explorerTheme";

const gridSx = explorerFilterGridSx as SxProps<Theme>;

const ExplorerPageSkeleton: React.FC = () => (
  <AppSkeletonTheme borderRadius="12px">
    <Box sx={explorerRootSx}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          bgcolor: "#fff",
          px: 2,
          pt: "calc(4px + env(safe-area-inset-top, 0px))",
          pb: "4px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 0.5,
            minHeight: 52,
          }}
        >
          <Skeleton circle width={40} height={40} />
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
              py: 0.5,
            }}
          >
            <Skeleton width="75%" height={18} />
            <Skeleton width="55%" height={16} />
          </Box>
          <Skeleton width={64} height={48} borderRadius={8} />
        </Box>
      </Box>

      <Box sx={explorerContentSx}>
        <Skeleton width={56} height={14} style={{ marginBottom: 10 }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            mb: 2.5,
          }}
        >
          <Skeleton
            height={EXPLORER_SEARCH_ROW_HEIGHT}
            borderRadius={999}
            style={{ flex: 1 }}
          />
          <Skeleton
            width={88}
            height={EXPLORER_SEARCH_ROW_HEIGHT}
            borderRadius={12}
          />
        </Box>

        <Skeleton width={88} height={14} style={{ marginBottom: 10 }} />
        <Box sx={gridSx}>
          {Array.from({ length: 9 }).map((_, i) => (
            <Skeleton key={`cat-${i}`} height={48} borderRadius={12} />
          ))}
        </Box>

        <Skeleton
          width={72}
          height={14}
          style={{ marginTop: 20, marginBottom: 10 }}
        />
        <Box sx={gridSx}>
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={`sz-${i}`} height={48} borderRadius={12} />
          ))}
        </Box>

        <Box sx={{ mt: 2.5, textAlign: "center" }}>
          <Skeleton width="82%" height={18} style={{ margin: "0 auto 12px" }} />
          <Skeleton height={220} borderRadius={12} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1,
              mt: 1.5,
            }}
          >
            <Skeleton circle width={8} height={8} />
            <Skeleton circle width={8} height={8} />
            <Skeleton circle width={8} height={8} />
          </Box>
        </Box>
      </Box>
    </Box>
  </AppSkeletonTheme>
);

export default memo(ExplorerPageSkeleton);
